/**
 * Customer Account API 오퍼레이션 (정적 문서).
 * Storefront API가 아니므로 storefront codegen 스키마로 검증되지 않는다.
 */

export const caaCustomerQuery = `#graphql
  query CaaCustomer {
    customer {
      id
      firstName
      lastName
      displayName
      creationDate
      tags
      emailAddress {
        emailAddress
        marketingState
      }
      phoneNumber {
        phoneNumber
      }
      defaultAddress {
        address1
        address2
        city
        company
        country
        firstName
        formatted
        formattedArea
        id
        lastName
        name
        phoneNumber
        province
        territoryCode
        zip
        zoneCode
      }
      addresses(first: 50) {
        edges {
          node {
            address1
            address2
            city
            company
            country
            firstName
            formatted
            formattedArea
            id
            lastName
            name
            phoneNumber
            province
            territoryCode
            zip
            zoneCode
          }
        }
      }
      orders(first: 250, sortKey: PROCESSED_AT, reverse: true) {
        edges {
          node {
            id
            name
            number
            processedAt
            createdAt
            updatedAt
            cancelReason
            financialStatus
            fulfillmentStatus
            statusPageUrl
            currencyCode
            totalPrice {
              amount
              currencyCode
            }
            totalRefunded {
              amount
              currencyCode
            }
            totalShipping {
              amount
              currencyCode
            }
            subtotal {
              amount
              currencyCode
            }
            totalTax {
              amount
              currencyCode
            }
            totalDuties {
              amount
              currencyCode
            }
            paymentInformation {
              totalPaidAmount {
                amount
                currencyCode
              }
            }
            discountApplications(first: 20) {
              edges {
                node {
                  __typename
                  ... on AutomaticDiscountApplication {
                    title
                  }
                  ... on ManualDiscountApplication {
                    title
                    description
                  }
                  ... on DiscountCodeApplication {
                    code
                  }
                }
              }
            }
            shippingAddress {
              address1
              address2
              city
              company
              country
              firstName
              formatted
              formattedArea
              id
              lastName
              name
              phoneNumber
              province
              territoryCode
              zip
              zoneCode
            }
            billingAddress {
              address1
              address2
              city
              company
              country
              firstName
              formatted
              formattedArea
              id
              lastName
              name
              phoneNumber
              province
              territoryCode
              zip
              zoneCode
            }
            lineItems(first: 100) {
              edges {
                node {
                  id
                  title
                  quantity
                  refundableQuantity
                  variantId
                  variantTitle
                  variantOptions {
                    name
                    value
                  }
                  vendor
                  price {
                    amount
                    currencyCode
                  }
                  productId
                  productType
                  image {
                    url
                    altText
                    width
                    height
                  }
                  totalPrice {
                    amount
                    currencyCode
                  }
                  currentTotalPrice {
                    amount
                    currencyCode
                  }
                  totalDiscount {
                    amount
                    currencyCode
                  }
                  discountAllocations {
                    allocatedAmount {
                      amount
                      currencyCode
                    }
                    discountApplication {
                      __typename
                      ... on AutomaticDiscountApplication {
                        title
                      }
                      ... on ManualDiscountApplication {
                        title
                        description
                      }
                      ... on DiscountCodeApplication {
                        code
                      }
                    }
                  }
                }
              }
            }
            fulfillments(first: 10) {
              edges {
                node {
                  id
                  trackingInformation {
                    company
                    number
                    url
                  }
                }
              }
            }
            returns(first: 10) {
              edges {
                node {
                  id
                  name
                  status
                  returnLineItems(first: 20) {
                    edges {
                      node {
                        id
                        quantity
                        returnReason
                        lineItem {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
            drawStatus: metafield(namespace: "custom", key: "draw_status") {
              key
              type
              value
              namespace
            }
            featuredImage: metafield(namespace: "operation", key: "featured_image") {
              key
              type
              value
              namespace
            }
            featuredImages: metafield(namespace: "operation", key: "featured_images") {
              key
              type
              value
              namespace
            }
            isOffline: metafield(namespace: "custom", key: "isoffline") {
              key
              type
              value
              namespace
            }
            returnStatus: metafield(namespace: "return", key: "status") {
              key
              type
              value
              namespace
            }
            instagram: metafield(namespace: "custom", key: "instagram") {
              key
              type
              value
              namespace
            }
            serialNumber: metafield(namespace: "operation", key: "serial_number") {
              key
              type
              value
              namespace
            }
            score: metafield(namespace: "operation", key: "score") {
              key
              type
              value
              namespace
            }
            productCode: metafield(namespace: "operation", key: "product_code") {
              key
              type
              value
              namespace
            }
            cardInfo: metafield(namespace: "custom", key: "card_info") {
              key
              type
              value
              namespace
            }
            isfamilysale: metafield(namespace: "operation", key: "isfamilysale") {
              key
              type
              value
              namespace
            }
            brandStoreOrderIds: metafield(namespace: "custom", key: "brand_store_order_id") {
              key
              type
              value
              namespace
            }
            giftingIsAccepted: metafield(namespace: "custom", key: "gifting_is_accepted") {
              key
              type
              value
              namespace
            }
            giftingMessageTemplate: metafield(
              namespace: "custom"
              key: "gifting_message_template"
            ) {
              key
              type
              value
              namespace
            }
            giftingToken: metafield(namespace: "custom", key: "gifting_token") {
              key
              type
              value
              namespace
            }
            release_date: metafield(namespace: "operation", key: "release_date") {
              key
              type
              value
              namespace
            }
          }
        }
      }
      gender: metafield(namespace: "info", key: "gender") {
        key
        type
        value
        namespace
      }
      birth: metafield(namespace: "info", key: "birth") {
        key
        type
        value
        namespace
      }
      cardInfo: metafield(namespace: "custom", key: "card_info") {
        key
        type
        value
        namespace
      }
      wishlist: metafield(namespace: "info", key: "wishlist") {
        key
        type
        value
        namespace
      }
    }
  }
`;

/** jp(New Customer Accounts)용 원격 cartId 조회. 인증은 caaRequest 의 Authorization 헤더가 담당한다 */
export const caaCustomerCartIdQuery = `#graphql
  query CaaCustomerCartId {
    customer {
      id
      cartId: metafield(namespace: "info", key: "cart_id") {
        id
        key
        namespace
        value
        type
      }
    }
  }
`;

export const caaCustomerOrdersQuery = `#graphql
  query CaaCustomerOrders($first: Int, $sortKey: OrderSortKeys, $reverse: Boolean, $after: String) {
    customer {
      orders(first: $first, sortKey: $sortKey, reverse: $reverse, after: $after) {
        edges {
          node {
            id
            name
            number
            processedAt
            createdAt
            updatedAt
            cancelReason
            financialStatus
            fulfillmentStatus
            statusPageUrl
            currencyCode
            totalPrice {
              amount
              currencyCode
            }
            totalRefunded {
              amount
              currencyCode
            }
            totalShipping {
              amount
              currencyCode
            }
            subtotal {
              amount
              currencyCode
            }
            totalTax {
              amount
              currencyCode
            }
            totalDuties {
              amount
              currencyCode
            }
            paymentInformation {
              totalPaidAmount {
                amount
                currencyCode
              }
            }
            discountApplications(first: 20) {
              edges {
                node {
                  __typename
                  ... on AutomaticDiscountApplication {
                    title
                  }
                  ... on ManualDiscountApplication {
                    title
                    description
                  }
                  ... on DiscountCodeApplication {
                    code
                  }
                }
              }
            }
            shippingAddress {
              address1
              address2
              city
              company
              country
              firstName
              formatted
              formattedArea
              id
              lastName
              name
              phoneNumber
              province
              territoryCode
              zip
              zoneCode
            }
            billingAddress {
              address1
              address2
              city
              company
              country
              firstName
              formatted
              formattedArea
              id
              lastName
              name
              phoneNumber
              province
              territoryCode
              zip
              zoneCode
            }
            lineItems(first: 100) {
              edges {
                node {
                  id
                  title
                  quantity
                  refundableQuantity
                  variantId
                  variantTitle
                  variantOptions {
                    name
                    value
                  }
                  vendor
                  price {
                    amount
                    currencyCode
                  }
                  productId
                  productType
                  image {
                    url
                    altText
                    width
                    height
                  }
                  totalPrice {
                    amount
                    currencyCode
                  }
                  currentTotalPrice {
                    amount
                    currencyCode
                  }
                  totalDiscount {
                    amount
                    currencyCode
                  }
                  discountAllocations {
                    allocatedAmount {
                      amount
                      currencyCode
                    }
                    discountApplication {
                      __typename
                      ... on AutomaticDiscountApplication {
                        title
                      }
                      ... on ManualDiscountApplication {
                        title
                        description
                      }
                      ... on DiscountCodeApplication {
                        code
                      }
                    }
                  }
                }
              }
            }
            fulfillments(first: 10) {
              edges {
                node {
                  id
                  trackingInformation {
                    company
                    number
                    url
                  }
                }
              }
            }
            returns(first: 10) {
              edges {
                node {
                  id
                  name
                  status
                  returnLineItems(first: 20) {
                    edges {
                      node {
                        id
                        quantity
                        returnReason
                        lineItem {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
            drawStatus: metafield(namespace: "custom", key: "draw_status") {
              key
              type
              value
              namespace
            }
            featuredImage: metafield(namespace: "operation", key: "featured_image") {
              key
              type
              value
              namespace
            }
            featuredImages: metafield(namespace: "operation", key: "featured_images") {
              key
              type
              value
              namespace
            }
            isOffline: metafield(namespace: "custom", key: "isoffline") {
              key
              type
              value
              namespace
            }
            returnStatus: metafield(namespace: "return", key: "status") {
              key
              type
              value
              namespace
            }
            instagram: metafield(namespace: "custom", key: "instagram") {
              key
              type
              value
              namespace
            }
            serialNumber: metafield(namespace: "operation", key: "serial_number") {
              key
              type
              value
              namespace
            }
            score: metafield(namespace: "operation", key: "score") {
              key
              type
              value
              namespace
            }
            productCode: metafield(namespace: "operation", key: "product_code") {
              key
              type
              value
              namespace
            }
            cardInfo: metafield(namespace: "custom", key: "card_info") {
              key
              type
              value
              namespace
            }
            isfamilysale: metafield(namespace: "operation", key: "isfamilysale") {
              key
              type
              value
              namespace
            }
            brandStoreOrderIds: metafield(namespace: "custom", key: "brand_store_order_id") {
              key
              type
              value
              namespace
            }
            giftingIsAccepted: metafield(namespace: "custom", key: "gifting_is_accepted") {
              key
              type
              value
              namespace
            }
            giftingMessageTemplate: metafield(
              namespace: "custom"
              key: "gifting_message_template"
            ) {
              key
              type
              value
              namespace
            }
            giftingToken: metafield(namespace: "custom", key: "gifting_token") {
              key
              type
              value
              namespace
            }
            release_date: metafield(namespace: "operation", key: "release_date") {
              key
              type
              value
              namespace
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
        }
      }
    }
  }
`;

export const caaCustomerUpdateMutation = `#graphql
  mutation CaaCustomerUpdate($input: CustomerUpdateInput!) {
    customerUpdate(input: $input) {
      customer {
        id
        firstName
        lastName
        displayName
        creationDate
        tags
        emailAddress {
          emailAddress
          marketingState
        }
        phoneNumber {
          phoneNumber
        }
        defaultAddress {
          address1
          address2
          city
          company
          country
          firstName
          formatted
          formattedArea
          id
          lastName
          name
          phoneNumber
          province
          territoryCode
          zip
          zoneCode
        }
        addresses(first: 50) {
          edges {
            node {
              address1
              address2
              city
              company
              country
              firstName
              formatted
              formattedArea
              id
              lastName
              name
              phoneNumber
              province
              territoryCode
              zip
              zoneCode
            }
          }
        }
        orders(first: 250, sortKey: PROCESSED_AT, reverse: true) {
          edges {
            node {
              id
              name
              number
              processedAt
              createdAt
              updatedAt
              cancelReason
              financialStatus
              fulfillmentStatus
              statusPageUrl
              currencyCode
              totalPrice {
                amount
                currencyCode
              }
              totalRefunded {
                amount
                currencyCode
              }
              totalShipping {
                amount
                currencyCode
              }
              subtotal {
                amount
                currencyCode
              }
              totalTax {
                amount
                currencyCode
              }
              totalDuties {
                amount
                currencyCode
              }
              paymentInformation {
                totalPaidAmount {
                  amount
                  currencyCode
                }
              }
              discountApplications(first: 20) {
                edges {
                  node {
                    __typename
                    ... on AutomaticDiscountApplication {
                      title
                    }
                    ... on ManualDiscountApplication {
                      title
                      description
                    }
                    ... on DiscountCodeApplication {
                      code
                    }
                  }
                }
              }
              shippingAddress {
                address1
                address2
                city
                company
                country
                firstName
                formatted
                formattedArea
                id
                lastName
                name
                phoneNumber
                province
                territoryCode
                zip
                zoneCode
              }
              billingAddress {
                address1
                address2
                city
                company
                country
                firstName
                formatted
                formattedArea
                id
                lastName
                name
                phoneNumber
                province
                territoryCode
                zip
                zoneCode
              }
              lineItems(first: 100) {
                edges {
                  node {
                    id
                    title
                    quantity
                    refundableQuantity
                    variantId
                    variantTitle
                    variantOptions {
                      name
                      value
                    }
                    vendor
                    price {
                      amount
                      currencyCode
                    }
                    productId
                    productType
                    image {
                      url
                      altText
                      width
                      height
                    }
                    totalPrice {
                      amount
                      currencyCode
                    }
                    currentTotalPrice {
                      amount
                      currencyCode
                    }
                    totalDiscount {
                      amount
                      currencyCode
                    }
                    discountAllocations {
                      allocatedAmount {
                        amount
                        currencyCode
                      }
                      discountApplication {
                        __typename
                        ... on AutomaticDiscountApplication {
                          title
                        }
                        ... on ManualDiscountApplication {
                          title
                          description
                        }
                        ... on DiscountCodeApplication {
                          code
                        }
                      }
                    }
                  }
                }
              }
              fulfillments(first: 10) {
                edges {
                  node {
                    id
                    trackingInformation {
                      company
                      number
                      url
                    }
                  }
                }
              }
              returns(first: 10) {
                edges {
                  node {
                    id
                    name
                    status
                    returnLineItems(first: 20) {
                      edges {
                        node {
                          id
                          quantity
                          returnReason
                          lineItem {
                            id
                          }
                        }
                      }
                    }
                  }
                }
              }
              drawStatus: metafield(namespace: "custom", key: "draw_status") {
                key
                type
                value
                namespace
              }
              featuredImage: metafield(namespace: "operation", key: "featured_image") {
                key
                type
                value
                namespace
              }
              isOffline: metafield(namespace: "custom", key: "isoffline") {
                key
                type
                value
                namespace
              }
              returnStatus: metafield(namespace: "return", key: "status") {
                key
                type
                value
                namespace
              }
              instagram: metafield(namespace: "custom", key: "instagram") {
                key
                type
                value
                namespace
              }
              serialNumber: metafield(namespace: "operation", key: "serial_number") {
                key
                type
                value
                namespace
              }
              score: metafield(namespace: "operation", key: "score") {
                key
                type
                value
                namespace
              }
              productCode: metafield(namespace: "operation", key: "product_code") {
                key
                type
                value
                namespace
              }
              cardInfo: metafield(namespace: "custom", key: "card_info") {
                key
                type
                value
                namespace
              }
              isfamilysale: metafield(namespace: "operation", key: "isfamilysale") {
                key
                type
                value
                namespace
              }
              brandStoreOrderIds: metafield(namespace: "custom", key: "brand_store_order_id") {
                key
                type
                value
                namespace
              }
              giftingIsAccepted: metafield(namespace: "custom", key: "gifting_is_accepted") {
                key
                type
                value
                namespace
              }
              giftingMessageTemplate: metafield(
                namespace: "custom"
                key: "gifting_message_template"
              ) {
                key
                type
                value
                namespace
              }
              giftingToken: metafield(namespace: "custom", key: "gifting_token") {
                key
                type
                value
                namespace
              }
              release_date: metafield(namespace: "operation", key: "release_date") {
                key
                type
                value
                namespace
              }
            }
          }
        }
        gender: metafield(namespace: "info", key: "gender") {
          key
          type
          value
          namespace
        }
        birth: metafield(namespace: "info", key: "birth") {
          key
          type
          value
          namespace
        }
        cardInfo: metafield(namespace: "custom", key: "card_info") {
          key
          type
          value
          namespace
        }
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`;

export const caaCustomerAddressCreateMutation = `#graphql
  mutation CaaCustomerAddressCreate($address: CustomerAddressInput!, $defaultAddress: Boolean) {
    customerAddressCreate(address: $address, defaultAddress: $defaultAddress) {
      customerAddress {
        address1
        address2
        city
        company
        country
        firstName
        formatted
        formattedArea
        id
        lastName
        name
        phoneNumber
        province
        territoryCode
        zip
        zoneCode
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`;

export const caaCustomerAddressUpdateMutation = `#graphql
  mutation CaaCustomerAddressUpdate($addressId: ID!, $address: CustomerAddressInput, $defaultAddress: Boolean) {
    customerAddressUpdate(
      addressId: $addressId
      address: $address
      defaultAddress: $defaultAddress
    ) {
      customerAddress {
        address1
        address2
        city
        company
        country
        firstName
        formatted
        formattedArea
        id
        lastName
        name
        phoneNumber
        province
        territoryCode
        zip
        zoneCode
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`;

export const caaCustomerAddressDeleteMutation = `#graphql
  mutation CaaCustomerAddressDelete($addressId: ID!) {
    customerAddressDelete(addressId: $addressId) {
      deletedAddressId
      userErrors {
        code
        field
        message
      }
    }
  }
`;

export const caaCustomerEmailMarketingSubscribeMutation = `#graphql
  mutation CaaCustomerEmailMarketingSubscribe {
    customerEmailMarketingSubscribe {
      emailAddress {
        emailAddress
        marketingState
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`;

export const caaCustomerEmailMarketingUnsubscribeMutation = `#graphql
  mutation CaaCustomerEmailMarketingUnsubscribe {
    customerEmailMarketingUnsubscribe {
      emailAddress {
        emailAddress
        marketingState
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`;

export const caaOrderQuery = `#graphql
  query CaaOrder($id: ID!) {
    order(id: $id) {
      id
      name
      number
      processedAt
      createdAt
      updatedAt
      cancelReason
      financialStatus
      fulfillmentStatus
      statusPageUrl
      currencyCode
      totalPrice {
        amount
        currencyCode
      }
      totalRefunded {
        amount
        currencyCode
      }
      totalShipping {
        amount
        currencyCode
      }
      subtotal {
        amount
        currencyCode
      }
      totalTax {
        amount
        currencyCode
      }
      totalDuties {
        amount
        currencyCode
      }
      paymentInformation {
        totalPaidAmount {
          amount
          currencyCode
        }
      }
      discountApplications(first: 20) {
        edges {
          node {
            __typename
            ... on AutomaticDiscountApplication {
              title
            }
            ... on ManualDiscountApplication {
              title
              description
            }
            ... on DiscountCodeApplication {
              code
            }
          }
        }
      }
      shippingAddress {
        address1
        address2
        city
        company
        country
        firstName
        formatted
        formattedArea
        id
        lastName
        name
        phoneNumber
        province
        territoryCode
        zip
        zoneCode
      }
      billingAddress {
        address1
        address2
        city
        company
        country
        firstName
        formatted
        formattedArea
        id
        lastName
        name
        phoneNumber
        province
        territoryCode
        zip
        zoneCode
      }
      lineItems(first: 100) {
        edges {
          node {
            id
            title
            quantity
            refundableQuantity
            variantId
            variantTitle
            variantOptions {
              name
              value
            }
            vendor
            price {
              amount
              currencyCode
            }
            productId
            productType
            image {
              url
              altText
              width
              height
            }
            totalPrice {
              amount
              currencyCode
            }
            currentTotalPrice {
              amount
              currencyCode
            }
            totalDiscount {
              amount
              currencyCode
            }
            discountAllocations {
              allocatedAmount {
                amount
                currencyCode
              }
              discountApplication {
                __typename
                ... on AutomaticDiscountApplication {
                  title
                }
                ... on ManualDiscountApplication {
                  title
                  description
                }
                ... on DiscountCodeApplication {
                  code
                }
              }
            }
          }
        }
      }
      fulfillments(first: 10) {
        edges {
          node {
            id
            trackingInformation {
              company
              number
              url
            }
          }
        }
      }
      returns(first: 10) {
        edges {
          node {
            id
            name
            status
            returnLineItems(first: 20) {
              edges {
                node {
                  id
                  quantity
                  returnReason
                  lineItem {
                    id
                  }
                }
              }
            }
          }
        }
      }
      drawStatus: metafield(namespace: "custom", key: "draw_status") {
        key
        type
        value
        namespace
      }
      featuredImage: metafield(namespace: "operation", key: "featured_image") {
        key
        type
        value
        namespace
      }
      isOffline: metafield(namespace: "custom", key: "isoffline") {
        key
        type
        value
        namespace
      }
      returnStatus: metafield(namespace: "return", key: "status") {
        key
        type
        value
        namespace
      }
      instagram: metafield(namespace: "custom", key: "instagram") {
        key
        type
        value
        namespace
      }
      serialNumber: metafield(namespace: "operation", key: "serial_number") {
        key
        type
        value
        namespace
      }
      score: metafield(namespace: "operation", key: "score") {
        key
        type
        value
        namespace
      }
      productCode: metafield(namespace: "operation", key: "product_code") {
        key
        type
        value
        namespace
      }
      cardInfo: metafield(namespace: "custom", key: "card_info") {
        key
        type
        value
        namespace
      }
      isfamilysale: metafield(namespace: "operation", key: "isfamilysale") {
        key
        type
        value
        namespace
      }
      brandStoreOrderIds: metafield(namespace: "custom", key: "brand_store_order_id") {
        key
        type
        value
        namespace
      }
      giftingIsAccepted: metafield(namespace: "custom", key: "gifting_is_accepted") {
        key
        type
        value
        namespace
      }
      giftingMessageTemplate: metafield(
        namespace: "custom"
        key: "gifting_message_template"
      ) {
        key
        type
        value
        namespace
      }
      giftingToken: metafield(namespace: "custom", key: "gifting_token") {
        key
        type
        value
        namespace
      }
      release_date: metafield(namespace: "operation", key: "release_date") {
        key
        type
        value
        namespace
      }
    }
  }
`;
